/* MEG CJ menu V2: pointer hover on desktop; native details click and keyboard semantics retained. Review-only theme. */
(() => {
  const menuSelector = '[data-meg-cj-nav]';
  const setup = (menu) => {
    if (!menu || menu.dataset.megCjReady === 'true') return;
    menu.dataset.megCjReady = 'true';
    const summaries = Array.from(menu.querySelectorAll('.meg-cj-menu__item > summary'));
    let hoverTimer = null;
    const clearHover = () => {
      if (hoverTimer !== null) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    };
    const selectItem = (details) => {
      if (!details || !menu.contains(details)) return;
      menu.querySelectorAll('.meg-cj-menu__item').forEach(item => {
        if (item !== details && item.open) item.open = false;
      });
      if (!details.open) details.open = true;
    };
    summaries.forEach(summary => {
      summary.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
        if (matchMedia('(max-width: 800px)').matches) return;
        clearHover();
        hoverTimer = setTimeout(() => {
          if (menu.isConnected) selectItem(summary.parentElement);
          hoverTimer = null;
        }, 100);
      });
      summary.addEventListener('pointerleave', clearHover);
      summary.addEventListener('focus', clearHover);
    });
    menu.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const index = summaries.indexOf(document.activeElement);
      if (index === -1) return;
      event.preventDefault();
      clearHover();
      const direction = event.key === 'ArrowDown' ? 1 : -1;
      summaries[(index + direction + summaries.length) % summaries.length].focus();
    });
    menu.addEventListener('toggle', event => {
      const details = event.target;
      if (!details.matches?.('.meg-cj-menu__item') || !details.open) return;
      menu.querySelectorAll('.meg-cj-menu__item').forEach(item => {
        if (item !== details && item.open) item.open = false;
      });
    }, true);
  };
  const init = (root = document) => {
    root.querySelectorAll(menuSelector).forEach(setup);
    if (root.matches?.(menuSelector)) setup(root);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
